import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #161A29;
    padding: 90px 60px 90px 60px;

    @media (max-width: 768px) {
        padding: 20px 20px 30px 20px;
    }
`

export const Texto = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    margin: 0 0 15px 0;

    strong {
        color: #FFC455;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 28px;
        font-weight: 400;
        margin: 0 0 15px 0;
        text-align: center;
    }
`

export const BoxLink = styled.div`
    float: left;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;

    @media (max-width: 768px) {
        margin-top: 25px;
    }
`

export const Link = styled.a`
    background: #C98400;
    border-radius: 4px;
    padding: 12px 70px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
`